var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPaged
    ? _c("el-pagination", {
        class: {
          ypage: _vm.isSmall,
          ymiddle: _vm.isMiddle,
          ylarge: _vm.isLarge,
        },
        attrs: {
          small: _vm.small,
          "current-page": _vm.currentPages,
          "page-sizes": _vm.pageSizes,
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function ($event) {
            _vm.currentPages = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPages = $event
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }